/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Team_Bystep_NoteInputs */

const en_mk_team_bystep_note = /** @type {(inputs: Mk_Team_Bystep_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step and infrastructure allowances follow your plan.`)
};

const id_mk_team_bystep_note = /** @type {(inputs: Mk_Team_Bystep_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuota langkah dan infrastruktur mengikuti paketmu.`)
};

/**
* | output |
* | --- |
* | "Step and infrastructure allowances follow your plan." |
*
* @param {Mk_Team_Bystep_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_team_bystep_note = /** @type {((inputs?: Mk_Team_Bystep_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Team_Bystep_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_team_bystep_note(inputs)
	return en_mk_team_bystep_note(inputs)
});